import React from 'react';
import { RouteComponentProps } from 'react-router-dom';
import { CashieringRoute, ScheduledTransferDirection } from '@tradingblock/types';
import { BaseCashieringView } from '../BaseCashieringView';

interface ScheduledTransferViewProps extends RouteComponentProps<{ direction: string }> {}

export const ScheduledTransferView: React.FC<ScheduledTransferViewProps> = props => {
  const { match } = props;
  const direction =
    match.params.direction === 'withdrawal' ? ScheduledTransferDirection.Outgoing : ScheduledTransferDirection.Incoming;

  console.log({ direction, match: props.match.params.direction });

  return (
    <BaseCashieringView
      {...props}
      match={{
        ...props.match,
        params: {
          route: match.params.direction === 'withdrawal' ? CashieringRoute.Withdraw : CashieringRoute.Deposit,
        },
      }}
      scheduledTransferMode={true}
    />
  );
};
